import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AuthService} from '../services/auth.service';
import {environment} from '../../environments/environment';


export const AuthInterceptorSkipHeader = 'x-skip-auth-interceptor';

export const authInterceptorProvider = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  // Een eigen Authorization laten staan: het matchsheet-import werkt met een
  // token per league-omgeving (services/omgeving-api.service.ts).
  if (!request.headers.has(AuthInterceptorSkipHeader) && !request.headers.has('Authorization') && authService.token && (request.url.includes(environment.apiUrl) || request.url.includes(environment.authUrl))) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${authService.token}`,
      }
    });
  }

  return next(request);
}
